export default {
    list(state) {
        return state.list;
    },
    service(state) {
        return state.service;
    },
    loading(state) {
        return state.loading;
    },
    api(state) {
        return state.api
    },

    types(state) {
        return state.types
    },
    currentService(state) {
        return state.service
    }
}